import React from 'react'
import PropTypes from 'prop-types'
import { Nav, NavItem } from 'reactstrap'
import { SidebarContainer } from '../sidebar-container'
import { SidebarLink } from '../sidebar-link'
import { SessionStore } from '../../stores/session'
import { TaxRegistrationStore } from '../../stores/tax-registration'
import { inject, observer } from 'mobx-react'
import { CustomScrollbars } from './custom-scrollbars'
import Http from '../../services/http'
import { dataSources } from '../../utils/data-sources'
import { loadTaxRegistrationsData } from '../../contents/configuration/tax-registrations/load-data'

@inject('sessionStore', 'taxRegistrationStore')
@observer
class Sidebar extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isOnlineGateway: true
    }
    this.http = Http.getInstance(this.props.sessionStore)
    this.dataSources = dataSources()
  }

  componentDidMount () {
    if (!this.props.sessionStore.sysAdmin) {
      if (!this.props.taxRegistrationStore.taxRegistrationList) {
        loadTaxRegistrationsData(this.props.sessionStore, this.props.taxRegistrationStore)
      }
    }
  }

  submissionGatewaySubMenu () {
    return (
      <React.Fragment>
        <NavItem>
          <SidebarLink to='/submission-gateway' url={this.props.url}>
            <mosaic-icon name='settings' />
            <div>Overview</div>
          </SidebarLink>
        </NavItem>
        <NavItem>
          <SidebarLink to='/submission-gateway/authorisation' url={this.props.url} disabled={!this.props.taxRegistrationStore.hasOnlineSubmissionGateway}>
            <svg className='icon' aria-hidden='true'><use xlinkHref='#administrator_male' href='#administrator_male' /></svg>
            <div>Authorisation</div>
          </SidebarLink>
        </NavItem>
        <NavItem>
          <SidebarLink to='/submission-gateway/obligations' url={this.props.url}>
            <mosaic-icon name='date_span' />
            <div>Obligations</div>
          </SidebarLink>
        </NavItem>
        <React.Fragment>
          <NavItem>
            <SidebarLink to='/submission-gateway/tax-liabilities' url={this.props.url} disabled={!this.props.taxRegistrationStore.hasOnlineSubmissionGateway}>
              <mosaic-icon name='check' />
              <div>Tax liabilities</div>
            </SidebarLink>
          </NavItem>
          <NavItem>
            <SidebarLink to='/submission-gateway/tax-payments' url={this.props.url} disabled={!this.props.taxRegistrationStore.hasOnlineSubmissionGateway}>
              <mosaic-icon name='paycheque' />
              <div>Tax payments</div>
            </SidebarLink>
          </NavItem>
        </React.Fragment>
      </React.Fragment>
    )
  }

  sysAdminTenantMenu () {
    const checkForProvisioner = window.location.href.split('/').includes('provisioner')
    const menuCheck = (window.location.href.split('/').indexOf('admin') === window.location.href.split('/').length - 1)
    if (this.props.sessionStore.sysAdmin && !menuCheck && !checkForProvisioner) {
      return (
        <React.Fragment>
          <NavItem>
            <SidebarLink to='/admin/tenant/account' url={this.props.url}>
              <mosaic-icon name='settings' />
              <div>Account details</div>
            </SidebarLink>
            <SidebarLink to='/admin/tenant/submissions' url={this.props.url}>
              <mosaic-icon name='submit_resume' />
              <div>Submissions</div>
            </SidebarLink>
            {this.props.sessionStore.isSysAdminAdministrator &&
              <React.Fragment>
                <SidebarLink to='/admin/tenant/rename' url={this.props.url}>
                  <mosaic-icon name='rename' />
                  <div>Account rename</div>
                </SidebarLink>
                <SidebarLink to='/admin/tenant/datafix' url={this.props.url}>
                  <mosaic-icon name='maintenance' />
                  <div>Data fix</div>
                </SidebarLink>
              </React.Fragment>
            }
            <SidebarLink to='/admin/tenant/users' url={this.props.url}>
              <mosaic-icon name='user_group_man_man' />
              <div>Users</div>
            </SidebarLink>
            <SidebarLink to='/admin/tenant/authorisation' url={this.props.url}>
              <mosaic-icon name='inspection' />
              <div>Authorisation</div>
            </SidebarLink>
            {this.props.sessionStore.isSysAdminAdministrator &&
            <React.Fragment>
              <SidebarLink to='/admin/tenant/delete' url={this.props.url}>
                <mosaic-icon name='delete_sign' />
                <div>Delete</div>
              </SidebarLink>
            </React.Fragment>
            }
          </NavItem>
        </React.Fragment>
      )
    } else {
      return null
    }
  }

  sysAdminMenu () {
    if (this.props.sessionStore.sysAdmin) {
      return (
        <React.Fragment>
          <NavItem>
            <SidebarLink to='/admin' url={this.props.url}>
              <mosaic-icon name='list' />
              <div>Account list</div>
            </SidebarLink>
            {this.props.sessionStore.isSysAdminAdministrator &&
            <SidebarLink to='/admin/provisioner' url={this.props.url}>
              <mosaic-icon name='ingredients_list' />
              <div>List of sent URLs</div>
            </SidebarLink>
            }
          </NavItem>
        </React.Fragment>
      )
    } else {
      return null
    }
  }

  baseEditionMenu () {
    if (this.props.sessionStore.isBaseEdition) {
      return (
        <React.Fragment>
          <NavItem>
            <SidebarLink to='/' url={this.props.url}>
              <mosaic-icon name='home' />
              <div>Home</div>
            </SidebarLink>
          </NavItem>
          <NavItem>
            <SidebarLink to='/vat100-amendment' url={this.props.url}>
              <mosaic-icon name='accounting' />
              <div>VAT100 amendment</div>
            </SidebarLink>
          </NavItem>
          <NavItem>
            <SidebarLink to='/import' url={this.props.url}>
              <mosaic-icon name='import' />
              <div>Import</div>
            </SidebarLink>
          </NavItem>
          <NavItem>
            <SidebarLink to='/audit' url={this.props.url}>
              <mosaic-icon name='clock' />
              <div>Audit</div>
            </SidebarLink>
          </NavItem>
          <NavItem>
            <h4>Submission gateway</h4>
          </NavItem>
          {this.submissionGatewaySubMenu()}
          <NavItem>
            <h4>Configuration</h4>
          </NavItem>
          {this.props.sessionStore.isAdmin &&
          <React.Fragment>
            <NavItem>
              <SidebarLink to='/configuration' url={this.props.url}>
                <mosaic-icon name='settings' />
                <div>Overview</div>
              </SidebarLink>
            </NavItem>
            <NavItem>
              <SidebarLink to='/configuration/tax-registrations' url={this.props.url}>
                <mosaic-icon name='coins' />
                <div>Tax registrations</div>
              </SidebarLink>
            </NavItem>
            <NavItem>
              <SidebarLink to='/configuration/fms-connection' url={this.props.url}>
                <mosaic-icon name='data_configuration' />
                <div>FMS connections</div>
              </SidebarLink>
            </NavItem>
            <NavItem>
              <SidebarLink to='/configuration/users' url={this.props.url}>
                <mosaic-icon name='user_group_man_man' />
                <div>Users</div>
              </SidebarLink>
            </NavItem>
          </React.Fragment>
          }
          <NavItem>
            <SidebarLink to='/configuration/change-password' url={this.props.url}>
              <mosaic-icon name='password' />
              <div>Change password</div>
            </SidebarLink>
          </NavItem>
        </React.Fragment>
      )
    } else {
      return null
    }
  }

  fullEditionMenu () {
    if (this.props.sessionStore.isFullEdition) {
      return (
        <React.Fragment>
          <NavItem>
            <SidebarLink to='/' url={this.props.url}>
              <mosaic-icon name='home' />
              <div>Home</div>
            </SidebarLink>
          </NavItem>
          <NavItem>
            <SidebarLink to='/reconciliation' url={this.props.url}>
              <mosaic-icon name='scales' />
              <div>Reconciliation</div>
            </SidebarLink>
          </NavItem>
          <NavItem>
            <SidebarLink to='/audit' url={this.props.url}>
              <mosaic-icon name='clock' />
              <div>Audit</div>
            </SidebarLink>
          </NavItem>
          <NavItem>
            <SidebarLink to='/import' url={this.props.url}>
              <mosaic-icon name='import' />
              <div>Import</div>
            </SidebarLink>
          </NavItem>
          <React.Fragment>
            <NavItem>
              <SidebarLink to='/enhanced-search' url={this.props.url}>
                <mosaic-icon name='search' />
                <div>Enhanced search</div>
              </SidebarLink>
            </NavItem>
          </React.Fragment>
          <React.Fragment>
            <NavItem>
              <h4>Adjustment</h4>
            </NavItem>
            <NavItem>
              <SidebarLink to='/adjustment' url={this.props.url}>
                <mosaic-icon name='accounting' />
                <div>Overview</div>
              </SidebarLink>
            </NavItem>
            <React.Fragment>
              <NavItem>
                <h4>Journal</h4>
              </NavItem>
              <NavItem>
                <SidebarLink to='/journal' url={this.props.url}>
                  <svg className='icon' aria-hidden='true'><use xlinkHref='#accounting_' href='#accounting_' /></svg>
                  <div>Overview</div>
                </SidebarLink>
              </NavItem>
            </React.Fragment>
          </React.Fragment>
          <NavItem>
            <h4>Submission gateway</h4>
          </NavItem>
          {this.submissionGatewaySubMenu()}
          <NavItem>
            <h4>Configuration</h4>
          </NavItem>
          {(this.props.sessionStore.isAdmin || this.props.sessionStore.isApprover) &&
          <React.Fragment>
            <NavItem>
              <SidebarLink to='/configuration' url={this.props.url}>
                <mosaic-icon name='settings' />
                <div>Overview</div>
              </SidebarLink>
            </NavItem>
            <NavItem>
              <SidebarLink to='/configuration/tax-registrations' url={this.props.url}>
                <mosaic-icon name='coins' />
                <div>Tax registrations</div>
              </SidebarLink>
            </NavItem>
            <NavItem>
              <SidebarLink to='/configuration/tax-codes' url={this.props.url}>
                <mosaic-icon name='tags' />
                <div>Tax codes</div>
              </SidebarLink>
            </NavItem>
            <NavItem>
              <SidebarLink to='/configuration/tax-code-mapping' url={this.props.url}>
                <mosaic-icon name='map' />
                <div>Tax codes mapping</div>
              </SidebarLink>
            </NavItem>
            <NavItem>
              <SidebarLink to='/configuration/layout' url={this.props.url}>
                <mosaic-icon name='form' />
                <div>Layout</div>
              </SidebarLink>
            </NavItem>
            <NavItem>
              <SidebarLink to='/configuration/fms-connection' url={this.props.url}>
                <mosaic-icon name='data_configuration' />
                <div>FMS connections</div>
              </SidebarLink>
            </NavItem>
          </React.Fragment>
          }
          <NavItem>
            <SidebarLink to='/configuration/results-column-order' url={this.props.url}>
              <mosaic-icon name='columns' />
              <div>Results column order</div>
            </SidebarLink>
          </NavItem>
          {
            this.props.sessionStore.isAdmin &&
              <NavItem>
                <SidebarLink to='/configuration/users' url={this.props.url}>
                  <mosaic-icon name='user_group_man_man' />
                  <div>Users</div>
                </SidebarLink>
              </NavItem>
          }
          <NavItem>
            <SidebarLink to='/configuration/change-password' url={this.props.url}>
              <mosaic-icon name='password' />
              <div>Change password</div>
            </SidebarLink>
          </NavItem>
          {(this.props.sessionStore.isAdmin || this.props.sessionStore.isApprover) &&
          <NavItem>
            <SidebarLink to='/configuration/tolerance' url={this.props.url}>
              <mosaic-icon name='exposure_value' />
              <div>Tolerances</div>
            </SidebarLink>
          </NavItem>
          }
          {this.props.sessionStore.isAdmin &&
              <NavItem>
                <SidebarLink to='/configuration/workflow' url={this.props.url}>
                  <mosaic-icon name='workflow' />
                  <div>Workflow</div>
                </SidebarLink>
              </NavItem>
          }
        </React.Fragment>
      )
    } else {
      return null
    }
  }

  render () {
    return (
      <SidebarContainer>
        <CustomScrollbars
          autoHeight
          autoHeightMin={10}
          autoHeightMax={'calc(100vh - 70px)'}
          style={{ width: 250 }}>
          <div className='sidebar my-4'>
            <div className='nav-sidebar w-100' aria-label='sidebar' role='navigation' id='sidebarNav'>
              <Nav vertical>
                {this.sysAdminMenu()}
                {this.sysAdminTenantMenu()}
                {this.baseEditionMenu()}
                {this.fullEditionMenu()}
              </Nav>
            </div>
          </div>
        </CustomScrollbars>
      </SidebarContainer>
    )
  }
}

Sidebar.propTypes = {
  url: PropTypes.object,
  sessionStore: PropTypes.instanceOf(SessionStore),
  taxRegistrationStore: PropTypes.instanceOf(TaxRegistrationStore)
}

export { Sidebar }
